import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, of, take } from 'rxjs';
import { DocksModel } from 'src/app/models/DocksModel';
import { ReceivingService } from 'src/app/services/receiving/receiving.service';

@Component({
  selector: 'app-trip-details-rec',
  templateUrl: './trip-details-rec.component.html',
  styleUrl: './trip-details-rec.component.css'
})
export class TripDetailsRecComponent {
  dateInterval: any
  updateInterval: any

  recDocks: DocksModel[] = []
  dockId!: number
  dockData?: DocksModel
  activeDock: boolean = false;


  bgColor: string = '#FFF';

  takt: string = ""
  currentTimeInMs = Date.now()
  currentDate = new Date(this.currentTimeInMs).toString()

  constructor(
    private recService: ReceivingService,
    private route: ActivatedRoute) { }


  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.dockId = +params['id']
    })
    this.updateData();

    if (this.shouldUpdateDockInfo()) {
        this.updateDefaultTimer()
      } else { this.resetTimer() }
      
    this.updateInterval = setInterval(() => {
      this.updateData();
    }, 5000)
    this.dateInterval = setInterval(() => {
      this.currentTimeInMs = Date.now();
      if (this.shouldUpdateDockInfo()) {
        this.updateDefaultTimer()
      } else { this.resetTimer() }
    }, 1000);
  }

  private updateData(): void {
    this.recService.getRecDocksData().pipe
      (take(1),
        catchError(() => {
          return of({ recDocks: [] })
        })
      ).subscribe(
        (response) => {
          this.recDocks = response.recDocks.map(d => ({
            ...d,
            status: new Date(d.status + 'Z')
          }));

          this.dockData = this.recDocks.find(dock => dock.id === this.dockId)
        }
      )
  }

  private updateDefaultTimer() {
    const statusTime = Number(this.dockData?.status);
    const standartTakt: number = 60 * 60 * 1000

    const remainingTime: number = standartTakt + statusTime - this.currentTimeInMs;

    this.takt = this.formatTime(remainingTime);
    this.taktBackgroundColor(remainingTime, standartTakt)
    this.activeDock = true
  }

  private shouldUpdateDockInfo() {
    return this.dockData?.truck == 1 && this.dockData.active == 1
  }

  private resetTimer() {
    const loadingTimer = "--:--:--"
    this.activeDock = false;
    this.bgColor = "#FFF"
    this.takt = loadingTimer;
  }

  ngOnDestroy(): void {
    clearInterval(this.dateInterval);
  }

  //* -------------------------------------------- COLORAÇÃO TELA DE FUNDO  -------------------------------------------- *//

  private taktBackgroundColor(remainingTime: number, standartTakt: number) {

    if (remainingTime < 0) {
      this.bgColor = '#FF2340';
      this.takt = '-' + this.takt;
    } else if (remainingTime < (standartTakt) / 3) {
      this.bgColor = '#F1C21B';
    } else {
      this.bgColor = '#3CB371';
    }
  }

  //* -------------------------------------------- FORMATAÇÃO DE NÚMEROS -------------------------------------------- *//

  private formatTime(milliseconds: number): string {
    const totalSeconds = Math.abs(Math.floor(milliseconds / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    //padStart preenche string partindo do início (esquerda), garantindo comprimento padrão da string
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }


  public extractTime(dateTimeString: Date | undefined): string {

    if (!dateTimeString) {
      console.error("Doca sem status definido");
      return "Horário não disponível";
    }

    const arrivalTime = dateTimeString

    const dateObject = new Date(String(arrivalTime));

    // Extrai o horário
    const formattedTime = dateObject.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    return formattedTime
  }
}
